import React from "react";
import { Table, TableBody } from "@mui/material";
import { TransferTableAmountRow, TransferTableHeaderRow, TransferTableTotalRow } from "./components/TransferTableRow";
import { red } from "@mui/material/colors";

// 売掛振替表
export default function SalesTransferTable({salesTransferInfo}) {
  return (
    <Table>
      <TableBody>
        <HeaderRow />
        {
          getSalesTransferRowData(salesTransferInfo).map((rowData) => AmountRow({rowData}))
        }
        <TotalRow rowData={getSalesTransferTotalData(salesTransferInfo)} />
      </TableBody>
    </Table>
  )
};

const bgcolors = {
  header: red[300],
  name: red[100],
  totalName: red[200],
  subjectName: red[50],
  totalAmount: red[100]
}

const HeaderRow = () => (
  <TransferTableHeaderRow
    name="売掛仕分け"
    requiredSubject
    bgcolor={bgcolors.header}
  />
);

const AmountRow = ({rowData}) => {

  return (
    <TransferTableAmountRow
      nameBgcolor={bgcolors.name}
      subjectBgcolor={bgcolors.subjectName}
      {...rowData}
    />
  )
};

const TotalRow = ({rowData}) => {

  return (
    <TransferTableTotalRow
      nameBgcolor={bgcolors.totalName}
      amountBgcolor={bgcolors.totalAmount}
      {...rowData}
    />
  )
};

const getSalesTransferRowData = (salesTransferInfo) => ([
  {
    key: "salesTransfer_I",
    index: "I.",
    name: "受託　 軽減税率対象 売掛",
    debitSubject: "82 売掛金",
    debitAmount: salesTransferInfo ? salesTransferInfo.entrustedSalesPriceIncludingReducedTax : null,
    creditSubject: "3011 売上",
    creditAmount: salesTransferInfo ? salesTransferInfo.entrustedSalesPriceIncludingReducedTax : null,
    nameBgcolor: bgcolors.name,
  },{
    key: "salesTransfer_J",
    index: "J.",
    name: "受託　 普通税率　　 売掛",
    debitSubject: "82 売掛金",
    debitAmount: salesTransferInfo ? salesTransferInfo.entrustedSalesPriceIncludingRegularTax : null,
    creditSubject: "3011 売上",
    creditAmount: salesTransferInfo ? salesTransferInfo.entrustedSalesPriceIncludingRegularTax : null,
    nameBgcolor: bgcolors.name,
  },{
    key: "salesTransfer_K",
    index: "K.",
    name: "受託外 軽減税率対象 売掛",
    debitSubject: "82 売掛金",
    debitAmount: salesTransferInfo ? salesTransferInfo.nonEntrustedSalesPriceIncludingReducedTax : null,
    creditSubject: "3011 売上",
    creditAmount: salesTransferInfo ? salesTransferInfo.nonEntrustedSalesPriceIncludingReducedTax : null,
    nameBgcolor: bgcolors.name,
  },{
    key: "salesTransfer_L",
    index: "L.",
    name: "受託外 普通税率　　 売掛",
    debitSubject: "82 売掛金",
    debitAmount: salesTransferInfo ? salesTransferInfo.nonEntrustedSalesPriceIncludingRegularTax : null,
    creditSubject: "3011 売上",
    creditAmount: salesTransferInfo ? salesTransferInfo.nonEntrustedSalesPriceIncludingRegularTax : null,
    nameBgcolor: bgcolors.name,
  },
]);

const getSalesTransferTotalData = (salesTransferInfo) => ({
  debitAmount : salesTransferInfo ? salesTransferInfo.totalSalesPrice : null,
  creditAmount : salesTransferInfo ? salesTransferInfo.totalSalesPrice : null,
});

